import * as React from 'react';
import {useTranslation} from 'react-i18next';
import styles from './ButtonEffects.module.css';
import {useRippleEffect} from '../../hooks/useRippleEffect';

type Props = {
	text: string;
	onClick?: any;
	type?: 'submit' | 'reset' | 'button' | undefined;
	disabled?: boolean;
	loading?: boolean;
	icon?: React.ReactNode;
	variant?: 'green' | 'blue';
};

const GreenButton = ({text, onClick, type, disabled, loading, icon, variant = 'green'}: Props) => {
	const {t} = useTranslation();
	const {ripples, createRipple} = useRippleEffect();

	const handleClick = (e: React.MouseEvent<HTMLButtonElement>) => {
		if (disabled || loading) return;
		
		createRipple(e);
		
		// Вызываем оригинальный onClick
		if (onClick) onClick(e);
	};

	const buttonClass = variant === 'blue' ? styles.blueButton : styles.greenButton;

	return (
		<button
			type={type}
			disabled={disabled || loading}
			onClick={handleClick}
			className={`review__btn btn-main btn-main-gray ${buttonClass} ${loading ? styles.loading : ''}`}
		>
			{icon && <span className={styles.iconContainer}>{icon}</span>}
			{loading ? t('Завантаження...') : t(text)}
			{ripples.map(ripple => (
				<span
					key={ripple.id}
					className={styles.ripple}
					style={{
						left: ripple.x - 10,
						top: ripple.y - 10,
					}}
				/>
			))}
		</button>
	);
};

export default GreenButton;
